import { render, staticRenderFns } from "./RootCauseAnalysisForm.vue?vue&type=template&id=6fa312ab&"
import script from "./RootCauseAnalysisForm.vue?vue&type=script&lang=js&"
export * from "./RootCauseAnalysisForm.vue?vue&type=script&lang=js&"
import style0 from "./RootCauseAnalysisForm.vue?vue&type=style&index=0&id=6fa312ab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports